import demandConfig from 'services/metaData/demandConfig';

export const createLeftMenuData = () => [
    // partnership 1-3
    {
        name: 'MONETIZE',
        id: 'monetize',
        permissions: ['monetizerAny'],
        icon: {
            width: 16,
            height: 14,
            name: 'diamondIcon'
        },
        pageGroups: [
            {
                name: 'Dashboard',
                id: 'mainDashboard',
                path: '/',
                inlineLink: '/applications/new',
                inlineLinkText: '+ Add app',
                inlineLinkPermissions: ['manageApps'],
                actionIsExternal: false,
                permission: ['anyPartner']
            },
            {
                name: 'REPORTS',
                id: 'reports',
                pages: [
                    {
                        name: 'Performance',
                        id: 'monetizeMediationReports',
                        permissions: ['monetizerAny', '!monetizerTester'],
                        path: '/monetize/reports/mediation',
                        enableRepeatClick: true
                    },
                    {
                        name: 'User Activity',
                        id: 'monetizeMediationUserActivityReports',
                        permissions: ['monetizerAny', '!monetizerTester'],
                        path: '/monetize/reports/userActivity',
                        enableRepeatClick: true
                    },
                    {
                        name: 'Bidding',
                        id: 'biddingReports',
                        permissions: ['monetizerAny', '!monetizerTester', 'enableInAppBiddingReport'],
                        path: '/monetize/reports/bidding'
                    },
                    {
                        name: 'Cohorts',
                        id: 'mediationCohortReports',
                        permissions: ['monetizerAny', '!monetizerTester'],
                        path: '/monetize/reports/cohort'
                    },
                    {
                        name: 'Report Generator',
                        id: 'reportGenerator',
                        permissions: ['monetizerAny', '!monetizerTester'],
                        path: '/monetize/reports/reportGenerator',
                        hideOnMobile: true
                    },
                    {
                        name: 'ironSource Network',
                        id: 'monetizeReports',
                        permissions: ['monetizerAny', '!monetizerTester', '!demoAccount'],
                        path: '/monetize/reports'
                    }
                ]
            },
            {
                name: 'MANAGEMENT',
                id: 'monetizeMediation',
                hideOnMobile: true,
                pages: [
                    {
                        name: 'Mediation',
                        id: 'monetizeMediationManage',
                        permissions: ['mediationConfigured', '!monetizerTester'],
                        hideOnMobile: true,
                        path: '/monetize/mediation/manage'
                    },
                    {
                        name: 'Segments',
                        id: 'mediationSegmentsRules',
                        permissions: ['monetizer', '!monetizerTester'],
                        hideOnMobile: true,
                        path: '/monetize/segments'
                    }
                ]
            },
            {
                name: 'SETUP',
                id: 'monetizeSettings',
                hideOnMobile: true,
                pages: [
                    {
                        name: 'Ad Units & Placements',
                        id: 'monetizeAppSettings',
                        permissions: ['monetizer'],
                        hideOnMobile: true,
                        path: '/monetize/adSettings'
                    },
                    {
                        name: 'Server Side Networks',
                        id: 'mediationServerSideSetup',
                        permissions: ['serverSideIntegration'],
                        hideOnMobile: true,
                        path: '/monetize/mediation/serverSideSetup'
                    },
                    {
                        name: 'SDK Networks',
                        id: 'monetizeMediationSetup',
                        permissions: ['monetizer'],
                        hideOnMobile: true,
                        path: '/monetize/mediation/setup'
                    },
                    {
                        name: 'A/B',
                        id: 'monetizeABTestConfig',
                        permissions: ['monetizer'],
                        hideOnMobile: true,
                        path: '/monetize/abTestConfig'
                    },
                    {
                        name: 'Cross Promotion',
                        id: 'crossPromotion',
                        permissions: ['monetizer', 'enableCrossPromotion'],
                        hideOnMobile: true,
                        path: '/monetize/crossPromotion'
                    },
                    {
                        name: 'Direct Deals',
                        id: 'directDeals',
                        permissions: ['directDeals', '!viewer', '!monetizerTester'],
                        openInNewTab: true,
                        externalRoute: true
                    },
                    {
                        name: 'Testing',
                        id: 'monetizeAppTestSettings',
                        permissions: ['monetizer'],
                        hideOnMobile: true,
                        path: '/monetize/adTestSettings'
                    }
                ]
            },
            {
                name: 'Activity Logs',
                id: 'activityLogs',
                hideOnMobile: true,
                path: '/monetize/activityLogs',
                permissions: ['monetizerAny']
            }
        ]
    },
    {
        name: 'PROMOTE',
        id: 'advdash',
        icon: {
            width: 14,
            height: 14,
            name: 'spaceshipIcon'
        },
        permissions: ['advertiser'],
        pageGroups: [
            {
                name: 'Campaigns',
                id: 'advManagement',
                permissions: ['manageCampaigns'],
                path: demandConfig.getPathUrl('/management'),
                inlineLink: demandConfig.getPathUrl('/generator/new'),
                inlineLinkText: '+ New',
                actionIsExternal: true,
                externalRoute: true
            },
            {
                name: 'Overview',
                id: 'advOverview',
                permissions: ['advertiser'],
                path: demandConfig.getPathUrl('/overview'),
                externalRoute: true
            },
            {
                name: 'Analysis',
                id: 'advAnalysis',
                permissions: ['advertiser'],
                path: demandConfig.getPathUrl('/analysis'),
                externalRoute: true
            }
        ]
    },
    {
        name: 'UA HUB',
        id: 'uaHub',
        icon: {
            width: 15,
            height: 15,
            name: 'uaHubIcon'
        },
        permissions: ['uaHub'],
        path: demandConfig.getPathUrl('/ua-hub/analysis'),
        externalRoute: true
    },
    {
        name: 'CONVERSION VALUE',
        id: 'conversionValue',
        icon: {
            width: 14,
            height: 14,
            name: 'ios14Icon'
        },
        permissions: ['enableCVManager'],
        pageGroups: [
            {
                name: 'CV Manager',
                id: 'cvManager',
                permissions: ['enableCVManager'],
                path: '/conversionValue/cvManager/'
            }
        ]
    },
    // partnership 4
    {
        name: 'REPORTS',
        id: 'tdUserReports',
        path: '/trading-desk/reports',
        permissions: ['tradingDeskUser'],
        icon: {
            width: 20,
            height: 20,
            name: 'tableIcon'
        }
    },
    // admin pages
    {
        name: 'GENERAL',
        id: 'admin',
        icon: {
            width: 15,
            height: 15,
            name: 'appsIcon'
        },
        permissions: ['admin'],
        pageGroups: [
            {
                name: 'Manage Companies',
                id: 'adminCompany',
                permissions: ['manageCompanies'],
                path: '/admin/company'
            }
        ]
    },
    {
        name: 'DEMAND',
        id: 'demandAdmin',
        icon: {
            width: 14,
            height: 14,
            name: 'spaceshipIcon'
        },
        permissions: ['admin'],
        pageGroups: [
            {
                name: 'Click URL Validation',
                id: 'clickValidation',
                permissions: ['clickUrlValidationDB'],
                path: '/admin/clickValidation'
            },
            {
                name: 'Manage Invoices',
                id: 'adminManageInvoices',
                permissions: ['manageInvoices'],
                path: '/admin/manageInvoices'
            },
            {
                name: 'Approve Invoices',
                id: 'adminInvoice',
                permissions: ['financeTeamInvoicer'],
                path: '/admin/approveInvoices'
            },
            {
                name: 'Back Office',
                id: 'adminOperationsPage',
                permissions: ['admin'],
                path: demandConfig.getPathUrl('/back-office'),
                externalRoute: true
            },
            {
                name: 'Optimizer Rollback',
                id: 'optimizerRollback',
                permissions: ['createOptimizerRollbacks'],
                path: demandConfig.getPathUrl('/optimizer-rollback'),
                externalRoute: true
            },
            {
                name: 'Promote Management',
                id: 'promoteManagement',
                permissions: ['createPromote'],
                path: demandConfig.getPathUrl('/promote-management'),
                externalRoute: true
            }
        ]
    },
    {
        name: 'SUPPLY',
        id: 'supplyAdmin',
        icon: {
            width: 16,
            height: 14,
            name: 'diamondIcon'
        },
        permissions: ['admin'],
        pageGroups: [
            {
                name: 'Application Back Office',
                id: 'adminApplicationBackOfficeReview',
                permissions: ['manageCompanies'],
                path: '/admin/applicationBackOfficeReview'
            },
            {
                name: 'Publisher Back Office',
                id: 'adminPublisherBackOfficeReview',
                permissions: ['manageCompanies'],
                path: '/admin/publisherBackOfficeReview'
            },
            {
                name: 'Mediation Dashboard',
                id: 'adminMediationDashboard',
                permissions: ['viewMediationDashboard'],
                path: '/admin/mediationDash'
            },
            {
                name: 'Manage Corporates',
                id: 'adminCorporate',
                permissions: ['manageCorporates'],
                path: '/admin/corporate'
            }
        ]
    },
    {
        name: 'INTERNAL',
        id: 'internalAdmin',
        icon: {
            width: 14,
            height: 14,
            name: 'userIcon'
        },
        permissions: ['internalAdmin'],
        pageGroups: [
            {
                name: 'USERS',
                id: 'adminUsers',
                pages: [
                    {
                        name: 'User Management',
                        id: 'adminUserManagement',
                        permissions: ['internalUserManager'],
                        path: '/admin/userManagement'
                    }
                ]
            },
            {
                name: 'ROLES MANAGEMENT',
                id: 'adminRolesManagement',
                pages: [
                    {
                        name: 'Internal Roles',
                        id: 'adminInternalRoles',
                        permissions: ['rolesView'],
                        path: '/admin/roleManagement/internal'
                    },
                    {
                        name: 'External Roles',
                        id: 'adminExternalRoles',
                        permissions: ['rolesView'],
                        path: '/admin/roleManagement/external'
                    }
                ]
            }
        ]
    },
    {
        name: 'FINANCE',
        id: 'financeAdmin',
        icon: {
            width: 15,
            height: 15,
            name: 'walletIcon'
        },
        permissions: ['financeAdmin'],
        pageGroups: [
            {
                name: 'Manage Billing',
                id: 'adminGenerateBilling',
                permissions: ['billing'],
                path: '/admin/generateBilling'
            },
            {
                name: 'Approve Billing',
                id: 'adminApproveBilling',
                permissions: ['billing'],
                path: '/admin/approveBilling'
            },
            {
                name: 'Manage Payments',
                id: 'adminApprovePayments',
                permissions: ['billing'],
                path: '/admin/approvePayments'
            },
            {
                name: 'Priority Sync',
                id: 'adminDevelopers',
                permissions: ['developerSupport'],
                path: '/admin/prioritySync'
            }
        ]
    }
];
export const startClosedWidth = 1440;
export const mobileWidth = 1023;
export const openAllWidth = 1024;
export const startOverlayWidth = 1280;
